import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private pending = signal(0);
  isLoading = computed(() => this.pending() > 0);

  increment() { this.pending.update(v => v + 1); }
  decrement() { this.pending.update(v => Math.max(0, v - 1)); }
}
